export default __webpack_public_path__ + "static/media/location.138afc00.svg";